<template>
    <div class="best-seller-product pb-30">
        <div class="container">

            <div class="group-title" style="direction: rtl">
                <h3>{{ msg }}</h3>
            </div>

    <swiper
        :slidesPerView="1"
        :spaceBetween="5"
         navigation
         loop
        :pagination="{
      clickable: true,
    }"
        :breakpoints="{
      '640': {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      '768': {
        slidesPerView: 2,
        spaceBetween: 40,
      },
      '1024': {
        slidesPerView: 4,
        spaceBetween: 50,
      },
    }"
        :modules="modules"
        class="mySwiper"
    >

        <swiper-slide v-for="data in data_porforoshs.value" :key="data.id">

            <div class="single-product">
                <!-- Product Image Start -->
                <div class="pro-img">
                    <a v-bind:href="'/product/'+ data.slug">
                        <template v-if="data.photos[2].path_webp != null">
                        <picture>
                            <source v-bind:srcset="'../storage/photos/'+data.photos[2].path_webp" type="image/webp">
                            <source v-bind:srcset="'../storage/photos/'+data.photos[2].path" type="image/png">
                            <img class="primary-img" width="300" height="300" v-bind:src="'../storage/photos/'+data.photos[2].path" v-bind:alt="data.photos[2].alt_photo" v-bind:title="data.photos[2].title_photo">
                        </picture>
                        </template>
                        <template v-if="data.photos[2].path_webp == null">
                          <img class="primary-img" width="300" height="300" v-bind:src="'../storage/photos/'+data.photos[2].path" v-bind:alt="data.photos[2].alt_photo" v-bind:title="data.photos[2].title_photo">
                        </template>
                        </a>
                    </div>
                    <!-- Product Image End -->
                <!-- Product Content Start -->
                <div class="pro-content">

                    <h4><a v-bind:href="'/product/'+ data.slug">{{ data.title }}</a></h4>

                    <template v-if="inactive_price === '1'">
                        <p><span class="price">تماس بگیرید</span></p>
                    </template>
                    <template v-else>
                        <p><span class="price">{{data.price}}   ریال</span></p>
                    </template>

                    <div class="actions-primary">
                        <a class="box-shop" v-bind:href="'/product/'+ data.slug">برند: {{data.brand.title}}</a>
                    </div>

                </div>
                <template v-if="data.dicount != '0' ">
                    <span class="sticker-new">-{{data.dicount}}%</span>
                </template>

                <!-- Product Content End -->
            </div>

        </swiper-slide>

    </swiper>
        </div>
    </div>
</template>
<script>

    import "swiper/css";
    import 'swiper/css/navigation';
    import "swiper/css/pagination";
    import {reactive,ref} from 'vue'

    import axios from 'axios'

    import { Pagination,Navigation } from "swiper";
    import { Swiper, SwiperSlide } from "swiper/vue";

    export default {
        components: {
            Swiper,
            SwiperSlide,
        },
        props: ['inactive_price','msg'],
        setup(props) {
           // const posts = reactive([]);
            const data_porforoshs = reactive([]);
            const inactive_price = ref(props.inactive_price);
            const msg = ref(props.msg);
           // const errorText = reactive([]);
            const getPosts = async() => {
                    try {
                        await axios.get('/api/proforosh')
                   .then(res => {
                       data_porforoshs.value=res.data;
                   })
                    }catch (e) {
                        this.errors.push(e)
                    }
            }
            getPosts();
            return {
                modules: [Pagination,Navigation],
                data_porforoshs,
                inactive_price,
                msg

            };
        },

    };
</script>










